import script from "./fees.vue?vue&type=script&lang=tsx"
export * from "./fees.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__